import { client, useQuery } from '@fhs/client';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { IBackendCartEntries } from '@rbi-ctg/menu';

const DONATION_CART_ENTRIES = [
  {
    children: [],
    pickerSelections: '{}',
    lineId: 'donation-cart-id-temp',
    quantity: 1,
    sanityId: 'daa9e460-bb55-45ce-b0e2-c2c99d377434',
    type: 'Item',
    url: 'do-not-apply',
    name: '0.50 Donation',
    vendorConfigs: {
      ncr: {
        constantPlu: '200270',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      ncrDelivery: {
        constantPlu: '200270',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toast: {
        constantPlu: '900000000609407222/900000000609416219',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toastDelivery: {
        constantPlu: '900000000609407222/900000000609416219',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
    },
  },
  {
    children: [],
    lineId: 'donation-cart-id-temp',
    pickerSelections: '{}',
    quantity: 1,
    sanityId: '7a8dc90d-bf10-47d2-be35-37a4884f049f',
    type: 'Item',
    url: 'do-not-apply',
    name: '1.00 Donation',
    vendorConfigs: {
      ncr: {
        constantPlu: '200210',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      ncrDelivery: {
        constantPlu: '200210',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toast: {
        constantPlu: '900000000609407222/900000000609416221',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toastDelivery: {
        constantPlu: '900000000609407222/900000000609416221',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
    },
  },
  {
    children: [],
    lineId: 'donation-cart-id-temp',
    pickerSelections: '{}',
    quantity: 1,
    sanityId: '08810265-3c93-4b14-a1c9-9491fa920e66',
    type: 'Item',
    url: 'do-not-apply',
    name: '2.00 Donation',
    vendorConfigs: {
      ncr: {
        constantPlu: '200245',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      ncrDelivery: {
        constantPlu: '200245',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toast: {
        constantPlu: '900000000609407222/900000016554788062',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toastDelivery: {
        constantPlu: '900000000609407222/900000016554788062',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
    },
  },
  {
    children: [],
    lineId: 'donation-cart-id-temp',
    pickerSelections: '{}',
    quantity: 1,
    sanityId: 'f6b375bc-19cd-424b-98c1-6a87b173c9e7',
    type: 'Item',
    url: 'do-not-apply',
    name: '5.00 Donation',
    vendorConfigs: {
      ncr: {
        constantPlu: '200220',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      ncrDelivery: {
        constantPlu: '200220',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toast: {
        constantPlu: '900000000609407222/900000000609416223',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
      toastDelivery: {
        constantPlu: '900000000609407222/900000000609416223',
        pluType: 'constantPlu',
        pullUpLevels: null,
      },
    },
  },
];

export function useDonationCartEntries() {
  const { store } = useStoreContext();
  const storeId = store.number ?? '';
  const { serviceMode } = useServiceModeContext();

  return useQuery({
    queryKey: ['donations', storeId, serviceMode],
    enabled: Boolean(storeId && serviceMode),
    queryFn: async () => {
      const enrichedCartEntriesResponse = await client.queries.enrichCartEntries({
        cartEntries: JSON.stringify(DONATION_CART_ENTRIES),
        storeId,
        serviceMode,
      });

      const entries = enrichedCartEntriesResponse.data?.entries ?? [];

      return entries.map(entry => {
        return {
          ...entry,
          // override children to empty array so we don't have to deal
          //  with recursive reify logic. We know for sure these value should be empty.
          children: [],
          isDonation: true,
        };
      }) as Array<IBackendCartEntries>;
    },
  });
}
